import { CommonModule } from "@angular/common";
import { Component, HostListener } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "../../footer/footer.component";
import { NavService } from "../../../services/nav.service";
import { LayoutService } from "../../../services/layout.service";
import { Subscription } from "rxjs";
import { BreadcrumbService } from "../../../services/breadcrumb.service";

@Component({
  selector: "app-register",
  standalone:true,
  imports: [FooterComponent, CommonModule, RouterModule],
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})

export class RegisterComponent {

  public innerWidth : number;
  public footerFix = false;
  public footerLight = false;
  public footerDark : boolean = false;
  
  public breadcrumbProps = {
    title: '',
    preTitle: ''
  };
  private subscription: Subscription;

  constructor(
    public navService: NavService,
    public layoutService : LayoutService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit (){
    this.innerWidth = window.innerWidth;
    this.subscription = this.breadcrumbService.propertyChanged$.subscribe(value => {
      this.breadcrumbProps = value;
    });

  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (window.innerWidth < 1200) {
      this.layoutService.config.settings.sidebar_type = "page-wrapper compact-wrapper";
    }
  } 

  get layoutClass() {
    return (
      this.layoutService.config.settings.sidebar_type + '' 
    );
  }

  ngDoCheck() {
    if (window.location.pathname == "/page-layout/footer-dark") {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
    } else if (window.location.pathname == '/page-layout/footer-light') {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
    } else if (window.location.pathname == '/page-layout/footer-fixed') {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
    }
  }

  ngOnDestroy() {
    this.footerDark = false;
    
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  
}
